import { useMemo } from "react";
import { TForm, TInputElementProps, TInputParams } from "@/components/form/types";

export const isTForm = <T>(props: any): props is TForm<T> => {
    return (props as TForm<T>).props !== undefined;
}

const useProps = <T, >(props: TInputParams<T>): TInputElementProps<T> => {
    return useMemo(() => {
        if (isTForm<T>(props)) {
            return props.props;
        } else {
            return props;
        }
    }, [props]) as TInputElementProps<T>;
}

export default useProps;
